<template>
  <div class="copyright-application">
    <!-- 顶部横幅 -->
    <div class="hero-banner">
      <div class="container">
        <h1 class="hero-title">{{ $t('_bqyy._spsq') }}</h1>
        <p class="hero-subtitle">{{ $t('_bqyy._spsy') }}</p>
      </div>
    </div>

    <div class="container">
      <!-- 主要内容区域 -->
      <div class="content-wrapper">
        <!-- 左侧内容 -->
        <div class="main-content">
          <!-- 已申请状态 -->
          <section class="content-section" style="" v-if="info.status == 1">
            <h2 class="section-title" style="border-left-color: #26a69a; color: #26a69a; margin-bottom: 0">
              {{ $t('_bq._zzsqz') }}
            </h2>
          </section>

          <!-- 驳回消息 -->
          <section class="content-section rejected" v-if="info.status == 3">
            <h2 class="section-title rejected-title">{{ $t('_sq._bhbt') }}</h2>
            <div class="section-content">
              <div class="reject-label">{{ $t('_sq._bhyy') }}</div>
              <p class="reject-reason">{{ info.reason }}</p>
            </div>
          </section>

          <!-- 什么是影片版权合作 -->
          <section class="content-section">
            <h2 class="section-title">{{ $t('_bqyy._sphz') }}</h2>
            <div class="section-content">
              <p>{{ $t('_bqyy._sphzsm') }}</p>
            </div>
          </section>

          <!-- 申请好处 -->
          <section class="content-section">
            <h2 class="section-title">{{ $t('_bqyy._sqhch') }}</h2>
            <div class="benefits-grid">
              <div class="benefit-card">
                <div class="benefit-icon">📈</div>
                <h3>{{ $t('_bqyy._llfz') }}</h3>
                <p>{{ $t('_bqyy._llfzsm') }}</p>
              </div>
              <div class="benefit-card">
                <div class="benefit-icon">💰</div>
                <h3>{{ $t('_bqyy._sytg') }}</h3>
                <p>{{ $t('_bqyy._sytgsm') }}</p>
              </div>
              <div class="benefit-card">
                <div class="benefit-icon">⭐</div>
                <h3>{{ $t('_bqyy._yxhz') }}</h3>
                <p>{{ $t('_bqyy._yxhzsm') }}</p>
              </div>
            </div>
          </section>

          <!-- 预约条件 -->
          <section class="content-section">
            <h2 class="section-title">{{ $t('_bqyy._yytj') }}</h2>
            <div class="requirements">
              <div class="requirement-item">
                <div class="requirement-number">1</div>
                <div class="requirement-content">
                  <h3>{{ $t('_bqyy._sptg') }}</h3>
                  <p>{{ $t('_bqyy._sptgsm') }}</p>
                </div>
              </div>
            </div>
          </section>

          <!-- 输入内容 -->
          <section class="content-section">
            <h2 class="section-title">{{ $t('_bq._sqbz') }}</h2>
            <a-textarea v-model:value="content" class="custom-textarea" :placeholder="$t('_bq._sqbzsm')" :rows="6" />
          </section>

          <!-- 底部预约卡片（移动端显示） -->
          <div class="sidebar-mobile">
            <div class="reserve-card">
              <div class="reserve-header">
                <h3>{{ $t('_bqyy._ljyy') }}</h3>
                <p class="reserve-desc">{{ $t('_bqyy._yysm') }}</p>
              </div>
              <button class="reserve-card-btn" @click="showReservationForm = true">
                {{ $t('_bqyy._ljyy') }}
              </button>
            </div>
          </div>
        </div>

        <!-- 右侧预约卡片 -->
        <div class="sidebar">
          <div class="reserve-card">
            <div class="reserve-header">
              <h3>{{ $t('_bqyy._ljyy') }}</h3>
              <p class="reserve-desc">{{ $t('_bqyy._yysm') }}</p>
            </div>
            <button class="reserve-card-btn" @click="showReservationForm = true">
              {{ $t('_bqyy._ljyy') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 预约表单弹窗 -->
    <ReservationForm v-if="showReservationForm" @close="showReservationForm = false" @submit="apply" />
  </div>
</template>

<script>
import ReservationForm from '@/components/apply/ReservationForm.vue'

export default {
  name: 'CopyrightApplication',
  components: {
    ReservationForm
  },
  data() {
    return {
      showReservationForm: false,
      info: {},
      content: ''
    }
  },
  created() {
    this.getApply()
  },
  methods: {
    getApply() {
      this.$api.userApply.getApply().then((res) => {
        this.info = res.data || {}
      })
    },

    apply() {
      this.$message.loading({ content: '申请中...', key: 'msg' })

      this.$api.userApply
        .apply({ content: this.content })
        .then((res) => {
          this.showReservationForm = false
          if (res.code === 1) {
            this.$message.warning({ content: res.msg, key: 'msg' })
            return
          }
          this.$message.success({ content: res.msg || '申请成功', key: 'msg' })
          this.getApply()
        })
        .catch(() => {
          this.showReservationForm = false
          this.$message.error('申请失败，请重试')
        })
    }
  }
}
</script>

<style scoped>
/* ============================================================
   版权申请 - 深灰主题
   ============================================================ */

.copyright-application {
  min-height: 100vh;
  background: #14181c;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* ============================================================
   顶部横幅
   ============================================================ */
.hero-banner {
  background: linear-gradient(135deg, #1a1f26 0%, #2a3038 50%, #1a1f26 100%);
  padding: 60px 0;
  text-align: center;
  border-bottom: 1px solid #2a3038;
}

.hero-title {
  color: #e8edf2;
  font-size: 2.8rem;
  font-weight: 700;
  margin-bottom: 16px;
  letter-spacing: 1px;
}

.hero-subtitle {
  color: #8a949f;
  font-size: 1.2rem;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

/* ============================================================
   内容区域
   ============================================================ */
.content-wrapper {
  display: grid;
  grid-template-columns: 1fr 340px;
  gap: 32px;
  padding: 40px 0 60px;
}

/* ============================================================
   内容区块
   ============================================================ */
.content-section {
  background: #1a1f26;
  border-radius: 14px;
  padding: 28px 32px;
  margin-bottom: 20px;
  border: 1px solid #2a3038;
  transition: border-color 0.3s;
}

.content-section:hover {
  border-color: #3a4652;
}

.content-section.rejected {
  border-color: #ef5350;
  background: rgba(239, 83, 80, 0.06);
}

.section-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #e8edf2;
  margin-bottom: 16px;
  padding-left: 16px;
  border-left: 4px solid #ffb300;
}

.section-title.rejected-title {
  border-left-color: #ef5350;
  color: #ef5350;
}

.section-content {
  font-size: 1rem;
  line-height: 1.8;
  color: #b0bcc8;
}

.section-content p {
  margin: 0;
}

.reject-label {
  font-weight: 600;
  color: #ef5350;
  margin-bottom: 4px;
}

.reject-reason {
  color: #e8edf2;
  font-size: 1rem;
  padding: 8px 14px;
  background: rgba(239, 83, 80, 0.08);
  border-radius: 8px;
  margin-top: 4px;
}

/* ============================================================
   好处网格
   ============================================================ */
.benefits-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 20px;
}

.benefit-card {
  text-align: center;
  padding: 24px 18px;
  background: #0f1419;
  border-radius: 10px;
  border: 1px solid #2a3038;
  transition: all 0.3s ease;
}

.benefit-card:hover {
  border-color: #ffb300;
  transform: translateY(-4px);
}

.benefit-icon {
  font-size: 2.6rem;
  margin-bottom: 10px;
}

.benefit-card h3 {
  color: #e8edf2;
  font-size: 1.1rem;
  margin-bottom: 8px;
}

.benefit-card p {
  color: #8a949f;
  font-size: 0.9rem;
  line-height: 1.6;
  margin: 0;
}

/* ============================================================
   预约条件
   ============================================================ */
.requirements {
  margin-top: 16px;
}

.requirement-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px 24px;
  background: #0f1419;
  border-radius: 10px;
  border-left: 4px solid #ffb300;
  border: 1px solid #2a3038;
  border-left-width: 4px;
}

.requirement-number {
  background: #ffb300;
  color: #0b0d0f;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.requirement-content h3 {
  color: #e8edf2;
  font-size: 1.1rem;
  margin: 0 0 4px;
}

.requirement-content p {
  color: #8a949f;
  line-height: 1.6;
  margin: 0;
  font-size: 0.95rem;
}

/* ============================================================
   Textarea
   ============================================================ */
.custom-textarea {
  background: #0f1419 !important;
  border: 1px solid #2a3038 !important;
  border-radius: 10px !important;
  color: #e8edf2 !important;
  font-size: 14px !important;
  padding: 12px 16px !important;
  resize: vertical;
  transition: border-color 0.3s;
}

.custom-textarea:focus {
  border-color: #ffb300 !important;
  box-shadow: 0 0 0 3px rgba(255, 179, 0, 0.08) !important;
}

.custom-textarea::placeholder {
  color: #4a5662 !important;
}

/* ============================================================
   右侧预约卡片
   ============================================================ */
.sidebar {
  position: sticky;
  top: 100px;
  height: fit-content;
}

.sidebar-mobile {
  display: none;
}

.reserve-card {
  background: #1a1f26;
  border-radius: 14px;
  padding: 28px 24px;
  text-align: center;
  border: 1px solid #2a3038;
  transition: border-color 0.3s;
}

.reserve-card:hover {
  border-color: #3a4652;
}

.reserve-header h3 {
  color: #e8edf2;
  font-size: 1.4rem;
  margin: 0 0 10px;
}

.reserve-desc {
  color: #8a949f;
  line-height: 1.6;
  margin: 0 0 20px;
  font-size: 0.95rem;
}

.reserve-card-btn {
  background: linear-gradient(135deg, #ffb300, #f57c00);
  color: #0b0d0f;
  border: none;
  padding: 12px 30px;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
}

.reserve-card-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(255, 179, 0, 0.3);
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 1024px) {
  .content-wrapper {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .sidebar {
    position: static;
    display: none;
  }

  .sidebar-mobile {
    display: block;
    margin-top: 8px;
  }

  .benefits-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .hero-banner {
    padding: 40px 0;
  }

  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .content-wrapper {
    padding: 24px 0 40px;
  }

  .content-section {
    padding: 20px 18px;
  }

  .section-title {
    font-size: 1.2rem;
    padding-left: 12px;
  }

  .benefits-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .benefit-card {
    padding: 18px 14px;
  }

  .requirement-item {
    padding: 16px 18px;
  }

  .reserve-card {
    padding: 20px 18px;
  }

  .reserve-header h3 {
    font-size: 1.2rem;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 12px;
  }

  .hero-title {
    font-size: 1.6rem;
  }

  .hero-subtitle {
    font-size: 0.9rem;
  }

  .content-section {
    padding: 16px 14px;
    border-radius: 10px;
  }

  .section-title {
    font-size: 1.1rem;
  }

  .section-content {
    font-size: 0.9rem;
  }

  .benefit-card h3 {
    font-size: 1rem;
  }

  .benefit-card p {
    font-size: 0.85rem;
  }

  .requirement-content h3 {
    font-size: 1rem;
  }

  .requirement-content p {
    font-size: 0.85rem;
  }

  .requirement-number {
    width: 30px;
    height: 30px;
    font-size: 0.9rem;
  }

  .reserve-card-btn {
    font-size: 0.9rem;
    padding: 10px 20px;
  }

  .custom-textarea {
    font-size: 13px !important;
    padding: 10px 14px !important;
  }
}
</style>